// extracted by mini-css-extract-plugin
module.exports = {"loadingHeader":"loading_loadingHeader__2_IoY"};